import { useState, useContext } from "react";
import dayjs from "dayjs";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

// My Files
import UserAvatar from "../../../management/UserAvatar";
import firebase from "../../../../firebase";
import { UserContext } from "../../../../context";

export default function ProjectCommentInput(props) {
    const [text, setText] = useState("");
    // const [anchorEl, setAnchorEl] = useState(null);

    // const popoverOpen = Boolean(anchorEl);
    // const id = popoverOpen ? "simple-popover" : undefined;

    const { currentUserData } = useContext(UserContext);

    // function handlePopoverClose() {}

    // function handlePopoverClick() {
    //     // setAnchorEl(null);

    //     // Adds a link to the current video time
    //     if (props.videoPlayer) {
    //         let totalSeconds = Math.floor(
    //             props.videoPlayer.current.getCurrentTime()
    //         );

    //         // props.videoPlayer.current.currentTime // For React-Hls-Player

    //         if (totalSeconds < 60) {
    //             if (totalSeconds < 10) {
    //                 setText(text + "0:0" + totalSeconds + "@ ");
    //             } else {
    //                 setText(text + "0:" + totalSeconds + "@ ");
    //             }
    //         } else {
    //             let minutes = Math.floor(totalSeconds / 60);
    //             let seconds = Math.floor(totalSeconds % 60);

    //             if (seconds < 10) {
    //                 setText(text + minutes + ":0" + seconds + "@ ");
    //             } else {
    //                 setText(text + minutes + ":" + seconds + "@ ");
    //             }
    //         }
    //     }
    // }

    function handleTextInput(event) {
        let addedCharacter = getDifference(text, event.target.value);
        let deletedCharacter = getDifference(event.target.value, text);

        if (addedCharacter === "@" || deletedCharacter === "@") {
            return;
        }

        setText(event.target.value);

        // if (
        //     props.videoPlayer &&
        //     event.target.value.endsWith("@") &&
        //     event.target.value.length > text.length
        // ) {
        //     setAnchorEl(event.target);
        // }
    }

    function handleCancelClick() {
        setText("");
    }

    function getDifference(a, b) {
        var i = 0;
        var j = 0;
        var result = "";

        while (j < b.length) {
            if (a[i] !== b[j] || i === a.length) result += b[j];
            else i++;
            j++;
        }
        return result;
    }

    function handleCommentClick() {
        if (text !== "") {
            if (props.component && props.projectKey !== "") {
                firebase
                    .database()
                    .ref("projects")
                    .child(props.projectKey)
                    .child("components")
                    .child(props.component.key)
                    .child("comments")
                    .push({
                        text: text,
                        user: currentUserData.key,
                        userName: currentUserData.fullName,
                        date: dayjs().toString(),
                        deleted: false,
                    });

                setText("");
            }
        }
    }

    function isButtonHidden() {
        if (props.isReply) {
            return false;
        }

        if (text === "") {
            return true;
        }
    }

    return (
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
            <UserAvatar
                userOrHub={currentUserData}
                size={props.avatarSize}
                path="users"
            />
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <TextField
                    id="project-comment-input"
                    label="Add a comment"
                    multiline
                    minRows={2}
                    value={text}
                    fullWidth
                    onChange={handleTextInput}
                />
                {!isButtonHidden() && (
                    <Box
                        sx={{
                            mt: 1.25,
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                        }}
                    >
                        <Button
                            color="inherit"
                            onClick={handleCancelClick}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            disableElevation
                            onClick={handleCommentClick}
                            disabled={text === ""}
                        >
                            Comment
                        </Button>
                    </Box>
                )}
            </Box>
        </Box>
    );
}
